export interface ChatWindowProps {
  selectedConv: Conversation | null;
  messages: Message[];
  messagesLoading: boolean;
  currentUserId: number | null;
  newMessage: string;
  setNewMessage: React.Dispatch<React.SetStateAction<string>>;
  handleSendMessage: (e: React.FormEvent) => void;
  handleFileUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  uploadedFiles: File[];
  setUploadedFiles: React.Dispatch<React.SetStateAction<File[]>>;
  isMobile: boolean;
  formatTimestamp: (dateString: string) => string;
  groupMessagesByDate: (messages: Message[]) => { [key: string]: Message[] };
  formatDateHeader: (dateString: string) => { text: string; date: string };
  showHeader?: boolean;
  onBack?: () => void;
}

export interface Conversation {
  id: number;
  clientId: number;
  conciergeId?: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  status: ConversationStatus;
  category: ConversationCategory;
  otherParticipantName?: string;
  otherParticipantEmail?: string;
  familyId: number;
  lastMessageContent?: string;
  lastMessageDate?: string;
  unreadCount: number;
}

export interface ConversationListProps {
  conversations: Conversation[];
  families: Family[];
  onSelectConversation: (conversation: Conversation) => void;
  onSelectFamily?: (family: Family | null) => void;
  onConversationArchived?: () => void;
  onConversationDeleted?: () => void;
  showDate?: boolean;
  selectedConversation?: Conversation | null;
  onNewConversation?: () => void;
}

export enum ConversationStatus {
  NEW = 0,
  OPEN = 1,
  CLOSED = 2,
  ARCHIVED = 3,
}
export enum ConversationCategory {
  GENERAL = 0,
  ADDITIONAL_DOCUMENTS = 1,
}

export interface Family {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export interface Message {
  id: number;
  conversationId: number;
  senderId: number;
  content: string;
  sentDate: string;
  attachments?: Attachment[];
}

export interface Attachment {
  id: number;
  fileName: string;
  originalFileName?: string;
  uploadedAt: string;
  fileUrl?: string;
}